import { PHASE } from './env';

export type ABTest = {
  experimentId: string;
  featureType: string;
} & (
  | {
      defaultFeatureValue: string;
      variations: readonly string[];
    }
  | {
      defaultFeatureValue: boolean;
      variations: readonly boolean[];
    }
);

export const AB_TESTS = {
  HERO_AB_TEST_3: {
    experimentId: `hero_a_vs_b_3_${PHASE}`,
    featureType: `hero-test3-cta-${PHASE}`,
    defaultFeatureValue: false,
    variations: [false, true],
  },
} as const satisfies Record<string, ABTest>;

// satisfies를 사용해야 ABTestVariation로 variations의 타입을 string이 아닌 실제 추가한 값으로 추론할 수 있음

export type ABTestVariation<T extends ABTest> = T['variations'][number];
